import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { getImageUrl } from "../../utils/imageHelper";

export default function BannerHome({ homeData }) {
  const slideList = homeData?.slider?.length
    ? homeData.slider
    : [{ image: "/assets/img/slider/slider1.jpg" }];

  return (
    <div className="hero-slider swiper-container">
      <div className="swiper-wrapper">
        <Swiper
          modules={[Navigation, Pagination, Autoplay]}
          navigation={{
            nextEl: ".custom-next",
            prevEl: ".custom-prev",
          }}
          pagination={{ clickable: true }}
          autoplay={{ delay: 3500, disableOnInteraction: false }}
          loop={slideList.length > 1}
          speed={800}
          className="swiper-slide"
        >
          {slideList.map((item, index) => {
            const imageUrl = getImageUrl(item.image);
            const isFirst = index === 0;

            return (
              <SwiperSlide key={index}>
                <div
                  className="slide-inner slide-bg-image"
                  style={{
                    position: "relative",
                    width: "100%",
                    height: "100%",
                    overflow: "hidden",
                    backgroundColor: "#ffffffff",
                  }}
                >
                  <img
                    src={imageUrl}
                    alt="Vivashri Matrimony Best Matches"
                    fetchPriority={isFirst ? "high" : "low"}
                    loading={isFirst ? "eager" : "lazy"}
                    decoding={isFirst ? "sync" : "async"}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      objectPosition: "center center",
                      position: "absolute",
                      top: 0,
                      left: 0,
                      display: "block",
                    }}
                  />
                  <div className="container SliderContentsWrapper d-none">
                    <div className="SliderContents">
                      <div data-swiper-parallax="300" className="slide-title">
                        <h2>Start control of your professional destiny</h2>
                      </div>
                      <div data-swiper-parallax="400" className="slide-text">
                        <p>
                          Astrology predictions are based on the position and
                          movements of planets and celestial bodies in the
                          Universe that impact our life quality.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>

      <div className="swiper-pagination" />
      <div className="custom-next">
        <div className="swiper-button-next" />
      </div>
      <div className="custom-prev">
        <div className="swiper-button-prev" />
      </div>
    </div>
  );
}
